import { click } from '@testing-library/user-event/dist/click';
import React, { useEffect, useState } from 'react';
import Button from './Button';
import SvgIcons from './SvgIcons';

import PopUp from '../views/PopUp';

const AccordionHeading = (props) => {

    // let animClass="accordionHeading"; 
    // props.mainAccordionShowHide? animClass="accordionHeading active" : animClass="accordionHeading"; 

    // console.log("props.popup",props.popUp.popupContent);

    return (
        <>
            <div className='accordionHeadingContainer' >
                <Button classList='accordionHeading' data={props} clickFunction={props.ClickAcc} btnId={props.id + 'Btn'} className={props.id + '_iconImage'}>
                    {/* //SM094673_iconImage */}
                    <span className="text" value="categoryTitle">{props.CategoryTitile}</span>
                    <SvgIcons iconName={props.iconName} classList="accordionIcon caretForwardIcon"></SvgIcons>
                </Button>
            </div>
        </>
    )
}


export default AccordionHeading;